import axios from '@/api/axios';

// Загрузка аудио файла для продвинутого режима
export async function addFile(formData) {
  try {
    await axios.post('/audio/uploads', formData);
  } catch (error) {
    console.log(error);
  }
}

// Удаление файлов
export async function deleteFile() {
  try {
    await axios.post('/audio/delete');
  } catch (error) {
    console.log(error);
  }
}
